import { BrowserRouter, Route, Routes } from "react-router-dom";
import React from "react";
import Layout from "./modules/layout/components";
import Contact from "./modules/contact";
import TermsCondition from "./modules/TermsCondition/components";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms-and-conditions" element={<TermsCondition />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
